// @flow
import { connect } from 'react-redux';

import { setInviteCardOpen } from '../../../actions/conversation';
import { addNotification } from '../../../actions/cc-mode';

import InviteCard from './InviteCard';

const mapStateToProps = ({ scribeConversation: { status }, scribeTranscriptUI: { electronCaptionMode } }) => ({
  electronCaptionMode,
  status,
});

const mapDispatchToProps = {
  addNotification,
  setInviteCardOpen,
};

export default connect(mapStateToProps, mapDispatchToProps)(InviteCard);
